import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography, Container, Paper } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { colors } from "../utils/styles";

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: colors.cream }}>
      <Box sx={{ bgcolor: "primary.main", color: "white", py: 4, mb: 6 }}>
        <Container maxWidth="md">
          <Typography variant="h4" fontWeight="bold" textAlign="center">
            Direct Charges Application
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="md">
        <Box sx={{ display: "flex", gap: 4, justifyContent: "center", flexWrap: "wrap" }}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              flex: "1 1 280px",
              maxWidth: 400,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2
            }}
          >
            <NotificationsIcon sx={{ fontSize: 48, color: "primary.main" }} />
            <Typography variant="h6" fontWeight="bold" textAlign="center">
              Preliminary Notification (New)
            </Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Step-based form matching the latest wireframe and Form Requirements spec.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => navigate("/preliminary-notification")}
              sx={{ mt: "auto" }}
            >
              Open
            </Button>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}
